import BaseModel from "@/store/models/base";
import BankResolver from "../services/bank-resolver";

export default class PaymentOptionBankAccountModel extends BaseModel {
  /**
   * Identificador da conta bancária.
   *
   * @return {int}
   */
  get id() {
    return this.rawAttributes.id;
  }

  /**
   * Documento do titular da conta bancária.
   *
   * @return {string}
   */
  get doc() {
    return this.rawAttributes.doc;
  }

  /**
   * Retorna o documento do titular da conta bancária com máscara.
   *
   * @return {string}
   */
  get maskedDoc() {
    if (this.doc.length === 11) {
      return this.doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
    return this.doc
      .toUpperCase()
      .replace(
        /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
        "$1.$2.$3/$4-$5"
      );
  }

  /**
   * Código do banco.
   *
   * @return {string}
   */
  get bank() {
    return this.rawAttributes.bank;
  }

  /**
   * Nome do banco.
   *
   * @return {string}
   */
  get bankName() {
    return BankResolver.getName(this.bank);
  }

  /**
   * Código da agência do banco.
   *
   * @return {string}
   */
  get branch() {
    return this.rawAttributes.branch;
  }

  /**
   * Tipo da conta bancária.
   *
   * @return {string}
   */
  get type() {
    return this.rawAttributes.type;
  }

  /**
   * Número da conta bancaŕia.
   *
   * @return {string}
   */
  get account() {
    return this.rawAttributes.account;
  }

  /**
   * Nome do titular da conta.
   *
   * @return {string}
   */
  get favored() {
    return this.rawAttributes.favored;
  }
}
